"use strict";

var _classCallCheck = require("/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var Register = /*#__PURE__*/function () {
  function Register() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Register);

    this.data = data;
  }

  _createClass(Register, [{
    key: "set",
    value: function set(key, value) {
      this.data[key] = value;
      return this;
    }
  }, {
    key: "add",
    value: function add() {
      return this.set.apply(this, arguments);
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      delete this.data[key];
      return this;
    }
  }, {
    key: "remove",
    value: function remove() {
      return this["delete"].apply(this, arguments);
    }
  }, {
    key: "get",
    value: function get(key) {
      return this.data[key];
    }
  }, {
    key: "has",
    value: function has(key) {
      return Object.prototype.hasOwnProperty.call(this.data, key);
    }
  }, {
    key: "list",
    value: function list() {
      return Object.keys(this.data);
    }
  }]);

  return Register;
}();

var _default = Register;
exports["default"] = _default;